module.exports = __webpack_public_path__ + "static/media/4-6.6ab2369f.mp3";